import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck, Mail, Phone, MapPin } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { SITE } from "../lib/site";

const CONTENT = {
  ro: {
    overline: "POLITICĂ DE CONFIDENȚIALITATE · GDPR",
    title: "Cum protejăm datele dvs. personale",
    last_updated: "Ultima actualizare: decembrie 2025",
    back: "Înapoi la site",
    intro:
      "Această politică explică modul în care sunt colectate, utilizate și protejate datele cu caracter personal pe care le furnizați prin intermediul site-ului legal-expert.ro. Documentul respectă prevederile Regulamentului (UE) 2016/679 (GDPR) și ale Legii nr. 190/2018.",
    sections: [
      {
        title: "1. Operatorul de date",
        body: [
          "Operatorul datelor cu caracter personal colectate prin acest site este:",
          "• Nume: Lontis Nicolae Stelian",
          "• Calitate: Expert Tehnic Judiciar",
          "• Autorizație: Nr. 3710072019 · Seria 74788314062019",
          "• Domeniu: Autovehicule și circulație rutieră",
          "• Adresă: Chișoda, str. Smochinului nr. 6, jud. Timiș, România",
          "• Email: etj.nicolae.lontis@gmail.com",
          "• Telefon: +40 721 605 655",
        ],
      },
      {
        title: "2. Datele colectate",
        body: [
          "Prin formularul de contact al site-ului colectăm exclusiv următoarele categorii de date:",
          "• Nume și prenume",
          "• Adresă de email",
          "• Număr de telefon (opțional)",
          "• Tipul serviciului solicitat",
          "• Subiectul și conținutul mesajului",
          "Nu colectăm date sensibile (cod numeric personal, date medicale, biometrice, etc.). Vă rugăm să nu includeți în mesaj astfel de date.",
        ],
      },
      {
        title: "3. Scopul prelucrării",
        body: [
          "Datele dvs. sunt prelucrate exclusiv pentru:",
          "• Răspunsul la solicitarea dvs. de expertiză sau consultanță",
          "• Stabilirea unei programări sau întocmirea unei oferte",
          "• Comunicarea pe parcursul executării lucrării (dacă acceptăm colaborarea)",
          "Datele NU sunt folosite pentru marketing, publicitate, profilare automată sau transmise către terți în scop comercial.",
        ],
      },
      {
        title: "4. Temei legal",
        body: [
          "Prelucrarea se bazează pe:",
          "• Consimțământul explicit pe care îl exprimați bifând caseta de acceptare la trimiterea formularului (art. 6 alin. 1 lit. a GDPR)",
          "• Interesul legitim de a răspunde la o solicitare de servicii adresată direct (art. 6 alin. 1 lit. f GDPR)",
          "• Executarea unui contract de prestări servicii — în cazul în care colaborarea continuă (art. 6 alin. 1 lit. b GDPR)",
        ],
      },
      {
        title: "5. Durata păstrării datelor",
        body: [
          "Datele colectate prin formularul de contact sunt păstrate pentru o perioadă de maxim 12 luni de la primirea ultimei comunicări, după care sunt șterse automat sau la cerere.",
          "Pentru clienții cu care s-a încheiat un contract de expertiză, documentele aferente sunt păstrate conform termenelor legale specifice activității de expert tehnic judiciar.",
        ],
      },
      {
        title: "6. Drepturile dvs. conform GDPR",
        body: [
          "Aveți următoarele drepturi cu privire la datele dvs. personale:",
          "• Dreptul de acces — să știți ce date avem despre dvs.",
          "• Dreptul la rectificare — corectarea datelor inexacte",
          "• Dreptul la ștergere (\"dreptul de a fi uitat\")",
          "• Dreptul la restricționarea prelucrării",
          "• Dreptul la opoziție — vă puteți opune prelucrării",
          "• Dreptul la portabilitate — primirea datelor într-un format structurat",
          "• Dreptul de a retrage consimțământul în orice moment",
          "• Dreptul de a depune o plângere la Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP)",
          "Pentru exercitarea acestor drepturi, trimiteți un email la etj.nicolae.lontis@gmail.com. Răspundem în cel mult 30 de zile.",
        ],
      },
      {
        title: "7. Securitatea datelor",
        body: [
          "Datele dvs. sunt stocate în baze de date securizate, accesibile doar operatorului. Transmiterea formularului se face criptat (HTTPS / TLS).",
          "Site-ul este protejat împotriva accesului neautorizat prin: autentificare cu parolă, hashing bcrypt al parolelor, sesiuni cu termen limitat, blocare automată după 5 încercări greșite.",
        ],
      },
      {
        title: "8. Transferul către terți",
        body: [
          "Datele dvs. NU sunt vândute, închiriate sau partajate cu terți. Singurele excepții:",
          "• Furnizori de servicii tehnice strict necesare funcționării site-ului (găzduire, infrastructură cloud) — care acționează ca persoane împuternicite și sunt obligați contractual să respecte aceleași standarde de protecție",
          "• Autorități publice — în cazul unei solicitări legale (instanță, organe de cercetare)",
        ],
      },
      {
        title: "9. Cookie-uri",
        body: [
          "Site-ul folosește un singur tip de cookie tehnic necesar:",
          "• Cookie de sesiune pentru zona de administrare (utilizat doar de proprietarul site-ului, nu de vizitatori obișnuiți)",
          "Nu folosim cookie-uri de tracking, analytics, marketing sau publicitate.",
        ],
      },
      {
        title: "10. Contact pentru întrebări GDPR",
        body: [
          "Pentru orice întrebare legată de această politică sau de modul în care prelucrăm datele dvs., contactați-ne:",
          "• Email: etj.nicolae.lontis@gmail.com",
          "• Telefon: +40 721 605 655",
          "• Adresă poștală: Chișoda, str. Smochinului nr. 6, jud. Timiș",
          "În caz de nemulțumire, vă puteți adresa și ANSPDCP — www.dataprotection.ro.",
        ],
      },
      {
        title: "11. Modificări ale politicii",
        body: [
          "Această politică poate fi actualizată periodic. Versiunea curentă este afișată pe această pagină, cu data ultimei actualizări. Vizitatorii sunt invitați să consulte periodic acest document.",
        ],
      },
    ],
  },
  en: {
    overline: "PRIVACY POLICY · GDPR",
    title: "How we protect your personal data",
    last_updated: "Last updated: December 2025",
    back: "Back to site",
    intro:
      "This policy explains how personal data submitted through legal-expert.ro is collected, used and protected. The document complies with Regulation (EU) 2016/679 (GDPR) and Romanian Law no. 190/2018.",
    sections: [
      {
        title: "1. Data Controller",
        body: [
          "The controller of personal data collected through this website is:",
          "• Name: Lontis Nicolae Stelian",
          "• Capacity: Technical Judicial Expert",
          "• Authorization: No. 3710072019 · Series 74788314062019",
          "• Specialty: Vehicles and road traffic",
          "• Address: Chișoda, str. Smochinului nr. 6, Timiș county, Romania",
          "• Email: etj.nicolae.lontis@gmail.com",
          "• Phone: +40 721 605 655",
        ],
      },
      {
        title: "2. Data collected",
        body: [
          "Through the contact form we collect only the following data:",
          "• First and last name",
          "• Email address",
          "• Phone number (optional)",
          "• Type of service requested",
          "• Subject and message content",
          "We do not collect sensitive data (personal identification number, medical, biometric data, etc.). Please do not include such data in your message.",
        ],
      },
      {
        title: "3. Purpose of processing",
        body: [
          "Your data is processed solely for:",
          "• Responding to your expertise or consultation request",
          "• Scheduling an appointment or preparing an offer",
          "• Communicating during the execution of the work (if collaboration is agreed)",
          "Data is NOT used for marketing, advertising, automated profiling, or shared with third parties for commercial purposes.",
        ],
      },
      {
        title: "4. Legal basis",
        body: [
          "Processing is based on:",
          "• Explicit consent given by checking the acceptance box (Art. 6(1)(a) GDPR)",
          "• Legitimate interest in responding to a direct service request (Art. 6(1)(f) GDPR)",
          "• Performance of a service contract — if collaboration continues (Art. 6(1)(b) GDPR)",
        ],
      },
      {
        title: "5. Data retention",
        body: [
          "Data collected through the contact form is kept for a maximum of 12 months from the last communication, after which it is deleted automatically or on request.",
          "For clients who entered into an expertise contract, related documents are retained according to legal terms applicable to judicial technical experts.",
        ],
      },
      {
        title: "6. Your GDPR rights",
        body: [
          "You have the following rights regarding your personal data:",
          "• Right of access",
          "• Right to rectification",
          "• Right to erasure (\"right to be forgotten\")",
          "• Right to restriction of processing",
          "• Right to object",
          "• Right to data portability",
          "• Right to withdraw consent at any time",
          "• Right to lodge a complaint with the Romanian National Supervisory Authority for Personal Data Processing (ANSPDCP)",
          "To exercise these rights, send an email to etj.nicolae.lontis@gmail.com. We respond within 30 days.",
        ],
      },
      {
        title: "7. Data security",
        body: [
          "Your data is stored in secure databases accessible only to the operator. Form transmission is encrypted (HTTPS / TLS).",
          "The website is protected against unauthorized access by: password authentication, bcrypt password hashing, time-limited sessions, automatic lockout after 5 failed attempts.",
        ],
      },
      {
        title: "8. Third-party transfers",
        body: [
          "Your data is NOT sold, rented or shared with third parties. The only exceptions:",
          "• Technical service providers strictly necessary for the website's operation (hosting, cloud infrastructure) — who act as processors and are contractually bound to the same protection standards",
          "• Public authorities — under a legal request (court, investigation bodies)",
        ],
      },
      {
        title: "9. Cookies",
        body: [
          "The website uses only one type of technically necessary cookie:",
          "• Session cookie for the administration area (used only by the website owner, not by regular visitors)",
          "We do not use tracking, analytics, marketing or advertising cookies.",
        ],
      },
      {
        title: "10. Contact for GDPR questions",
        body: [
          "For any question related to this policy or how we process your data, contact us:",
          "• Email: etj.nicolae.lontis@gmail.com",
          "• Phone: +40 721 605 655",
          "• Postal address: Chișoda, str. Smochinului nr. 6, Timiș county",
          "In case of dissatisfaction, you may also address ANSPDCP — www.dataprotection.ro.",
        ],
      },
      {
        title: "11. Policy changes",
        body: [
          "This policy may be updated periodically. The current version is displayed on this page, with the date of the last update. Visitors are invited to consult this document periodically.",
        ],
      },
    ],
  },
};

export default function Privacy() {
  const { lang } = useLanguage();
  const c = CONTENT[lang] || CONTENT.ro;

  return (
    <div data-testid="privacy-page" className="min-h-screen bg-[#0A0A0A] text-white">
      <header className="border-b border-neutral-900 bg-black/60 backdrop-blur-xl sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link
            to="/"
            data-testid="back-to-home"
            className="inline-flex items-center gap-2 font-mono-tech text-[11px] uppercase tracking-[0.2em] text-neutral-400 hover:text-yellow-400 transition-colors"
          >
            <ArrowLeft className="h-3.5 w-3.5" />
            {c.back}
          </Link>
          <div className="flex items-center gap-2 text-yellow-400">
            <ShieldCheck className="h-4 w-4" />
            <span className="font-mono-tech text-[10px] uppercase tracking-[0.2em]">GDPR</span>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <div className="overline mb-4">{c.overline}</div>
        <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight">
          {c.title}
        </h1>
        <p className="mt-4 font-mono-tech text-xs uppercase tracking-[0.2em] text-neutral-500">
          {c.last_updated}
        </p>

        <p className="mt-10 text-neutral-300 text-base sm:text-lg leading-relaxed border-l-2 border-yellow-500 pl-6">
          {c.intro}
        </p>

        <div className="mt-14 space-y-12">
          {c.sections.map((sec, idx) => (
            <section key={idx} data-testid={`privacy-section-${idx}`}>
              <h2 className="font-display font-bold text-2xl sm:text-3xl text-white mb-4">
                {sec.title}
              </h2>
              <div className="space-y-3 text-neutral-300 text-base leading-relaxed">
                {sec.body.map((line, i) => (
                  <p key={i} className={line.startsWith("•") ? "pl-4 text-neutral-400" : ""}>
                    {line}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-16 border-t border-neutral-800 pt-10">
          <div className="overline mb-4">Contact rapid</div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <a
              href={`tel:${SITE.phoneRaw}`}
              className="bg-[#0d0d0d] border border-neutral-800 p-5 hover:border-yellow-500 transition-colors group"
            >
              <Phone className="h-4 w-4 text-yellow-400 mb-2" />
              <div className="text-xs font-mono-tech text-neutral-500 uppercase tracking-[0.15em]">Telefon</div>
              <div className="text-white text-sm mt-1 group-hover:text-yellow-400">{SITE.phone}</div>
            </a>
            <a
              href={`mailto:${SITE.email}`}
              className="bg-[#0d0d0d] border border-neutral-800 p-5 hover:border-yellow-500 transition-colors group"
            >
              <Mail className="h-4 w-4 text-yellow-400 mb-2" />
              <div className="text-xs font-mono-tech text-neutral-500 uppercase tracking-[0.15em]">Email</div>
              <div className="text-white text-sm mt-1 group-hover:text-yellow-400 break-all">{SITE.email}</div>
            </a>
            <div className="bg-[#0d0d0d] border border-neutral-800 p-5">
              <MapPin className="h-4 w-4 text-yellow-400 mb-2" />
              <div className="text-xs font-mono-tech text-neutral-500 uppercase tracking-[0.15em]">Adresă</div>
              <div className="text-white text-sm mt-1">{SITE.address}</div>
            </div>
          </div>
        </div>
      </main>

      <footer className="border-t border-neutral-900 py-10 mt-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 font-mono-tech text-[11px] uppercase tracking-[0.2em] text-neutral-500">
          © {new Date().getFullYear()} {SITE.expertName} · {c.back === "Înapoi la site" ? "Toate drepturile rezervate" : "All rights reserved"}.
        </div>
      </footer>
    </div>
  );
}
